import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import {Link, withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import axios from "axios";
import {AXIOS_CLIENT_TIMEOUT, searchRange} from "../../utils/globalConstants";
import 'react-toastify/dist/ReactToastify.css';
import {startLoading, stopLoading} from '../../ducks/loading';
import {convertSearchTextToCommaDelimiterString, directDownload, parseSearchValue, sortOptions, subtractDateByDay} from '../../utils/CommonUtils';
import Select from '../search-bar/Select';
import TextInput from '../search-bar/TextInput';
import {additionalPaymentMethodOptions, paymentMethodOptions, productTypeOptions, reflectionStatusOptions, transactionStatusOptions, transactionTypeOptions} from '../../utils/SelectOptions';
import Tooltip from '../common/Tooltip';
import DatePickerX from '../common/DatePickerX';
import {API_SALES_INVOICE_COUNT, API_SALES_INVOICE_LIST, API_SALES_INVOICE_LIST_DOWNLOAD, API_SALES_INVOICE_LIST_INHOUSE_DOWNLOAD, API_SALES_MULTIPLE_INVOICE_REFUND, API_SALES_SINGLE_INVOICE_REFUND, URL_PRODUCT_DETAIL, URL_REQUEST_LIST, URL_SALES_SALESPRODUCT} from '../../utils/urlConstants';
import {handleHttpError} from '../../utils/ErrorUtils';
import DataTableWrapperForListing from '../datable/DataTableWrapperForListing';
import BasePopup from '../popup/BasePopup';
import RequestRefundPopUp from '../popup/RequestRefundPopUp';
import {findDays} from '../../utils/invoiceAttributes';
import {checkEmptyRefundAmountForPartialRefund, checkRefundAmountExceedPaymentAmount, checkRefundAmountValidForPartialRefund, setZeroRefundAmountForPartialRefund} from '../../utils/RefundUtils';
import {toast} from 'react-toastify';

class InvoiceListPanel extends Component {
    constructor(props) {
        super(props);
        this.httpClient = axios.create({timeout: AXIOS_CLIENT_TIMEOUT});

        this.defaultSortName = "ORDER_DATE";

        this.state = {
            sales: [],
            selectedSales: [],

            searchDateButton: searchRange.ONE_WEEK,
            searchKeywordType: "",
            searchKeywordText: "",
            searchCountry: "",
            searchProductType: "",
            searchReflectionStatus: "",
            searchTransactionType: "",
            searchTransactionStatus: "",
            searchCurrency: "",
            searchPaymentMethod: "",
            searchAdditionalPaymentMethod: "",
            searchSortName: this.defaultSortName,
            searchSortAsc: false,

            getOrderDateStart: undefined,
            setOrderDateStart: undefined,
            getOrderDateEnd: undefined,
            setOrderDateEnd: undefined,

            totalRecord: 0,
            totalPage: 0,
            pageIndex: 1,
            pageSize: 15,

            openDownloadPopup: false,
            downloadRequestId: '',

            openSingleRefundPopup: false,
            openMultipleRefundPopup: false,

            currentInvoice: undefined,
            alertPopup: false,
        }

        this.defaultColumns = [
            {dataField: "invoiceIdLink", text: this.props.t("INVOICE_ID"), headerStyle: {width: "12rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "settlementAppId", text: this.props.t("SETTLEMENT_APP_ID"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "settlementAppName", text: this.props.t("SETTLEMENT_APP_NAME"), headerStyle: {width: "14rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "productIdLink", text: this.props.t("PRODUCT_ID"), headerStyle: {width: "12rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "productName", text: this.props.t("PRODUCT_NAME"), headerStyle: {width: "14rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "productType", text: this.props.t("PRODUCT_TYPE"), headerStyle: {width: "10rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "subscriptionGroupType", text: this.props.t("SUBSCRIPTION_GROUP_TYPE"), headerStyle: {width: "10rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "reflectionStatusDisplay", text: this.props.t("REFLECTION_STATUS"), headerStyle: {width: "10rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "buyer", text: this.props.t("BUYER_EMAIL"), headerStyle: {width: "14rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "buyerUid", text: this.props.t("BUYER_UID"), headerStyle: {width: "10rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "orderCustomerId", text: this.props.t("ORDER_CUSTOMER_ID"), headerStyle: {width: "12rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "country", text: this.props.t("COUNTRY"), headerStyle: {width: "12rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "currency", text: this.props.t("CURRENCY"), headerStyle: {width: "10rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "zipCode", text: this.props.t("ZIP_CODE"), headerStyle: {width: "10rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "paymentAmountDisplay", text: this.props.t("PAYMENT_AMOUNT"), headerStyle: {width: "10rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "samsungRewardsAmountDisplay", text: this.props.t("SAMSUNG_REWARDS_AMOUNT"), headerStyle: {width: "14rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "paymentMethod", text: this.props.t("PAYMENT_METHOD"), headerStyle: {width: "12rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "additionalPaymentMethod", text: this.props.t("ADDITIONAL_PAYMENT_METHOD"), headerStyle: {width: "14rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "transactionType", text: this.props.t("TRANSACTION_TYPE"), headerStyle: {width: "10rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "transactionStatus", text: this.props.t("TRANSACTION_STATUS"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "orderDate", text: this.props.t("ORDER_DATE"), headerStyle: {width: "10rem"}, sort: true, hidden: false, classes: () => "text-truncate"},
            {dataField: "cancelDate", text: this.props.t("REFUND"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
        ]

        this.multipleRefundColumns = [
            {dataField: "invoiceIdLink", text: this.props.t("INVOICE_ID"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "productIdLink", text: this.props.t("PRODUCT_ID"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "productName", text: this.props.t("PRODUCT_NAME"), headerStyle: {width: "14rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "productType", text: this.props.t("PRODUCT_TYPE"), headerStyle: {width: "10rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "reflectionStatusDisplay", text: this.props.t("REFLECTION_STATUS"), headerStyle: {width: "10rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "buyer", text: this.props.t("BUYER_EMAIL"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "country", text: this.props.t("COUNTRY"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "currency", text: this.props.t("CURRENCY"), headerStyle: {width: "10rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "paymentAmountDisplay", text: this.props.t("PAYMENT_AMOUNT"), headerStyle: {width: "10rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "samsungRewardsAmountDisplay", text: this.props.t("SAMSUNG_REWARDS_AMOUNT"), headerStyle: {width: "14rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "paymentMethod", text: this.props.t("PAYMENT_METHOD"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "additionalPaymentMethod", text: this.props.t("ADDITIONAL_PAYMENT_METHOD"), headerStyle: {width: "14rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "transactionType", text: this.props.t("TRANSACTION_TYPE"), headerStyle: {width: "10rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "transactionStatus", text: this.props.t("TRANSACTION_STATUS"), headerStyle: {width: "12rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
            {dataField: "orderDate", text: this.props.t("ORDER_DATE"), headerStyle: {width: "10rem"}, sort: false, hidden: false, classes: () => "text-truncate"},
        ]

        this.keywordTypeOptions = [
            {value: "BUYER", label: this.props.t("BUYER_EMAIL")},
            {value: "INVOICE_ID", label: this.props.t("INVOICE_ID")},
            {value: "PRODUCT_ID", label: this.props.t("PRODUCT_ID")},
            {value: "PRODUCT_NAME", label: this.props.t("PRODUCT_NAME")},
            {value: "SETTLEMENT_APP_ID", label: this.props.t("SETTLEMENT_APP_ID")},
            {value: "SETTLEMENT_APP_NAME", label: this.props.t("SETTLEMENT_APP_NAME")},
        ]

        this.sortFieldMapping = {
            'orderDate': 'ORDER_DATE',
            'invoiceIdLink': 'INVOICE_ID',
            'productIdLink': 'PRODUCT_ID',
            'productName': 'PRODUCT_NAME',
            'productType': 'PRODUCT_TYPE',
            'reflectionStatus': 'REFLECTION_STATUS',
            'orderCustomerId': 'ORDER_CUSTOMER_ID',
            'country': 'COUNTRY',
            'currency': 'CURRENCY',
            'paymentAmountDisplay': 'PAYMENT_AMOUNT',
            'paymentMethod': 'PAYMENT_METHOD',
        }
    }

    handleChangeSearchDateButton = (value) => () => {
        this.setState({searchDateButton: value});
        this.state.setOrderDateEnd(new Date());
        this.state.setOrderDateStart(subtractDateByDay(new Date(), value));
    }

    searchBody = () => {
        return {
            cpAppId: this.props.carousel.selectedAppId,
            keywordType: parseSearchValue(this.state.searchKeywordType),
            keywordText: convertSearchTextToCommaDelimiterString(this.state.searchKeywordText.trim()),
            dateStart: this.state.getOrderDateStart(),
            dateEnd: this.state.getOrderDateEnd(),
            country: parseSearchValue(this.state.searchCountry),
            productType: parseSearchValue(this.state.searchProductType),
            reflectionStatus: parseSearchValue(this.state.searchReflectionStatus),
            transactionType: parseSearchValue(this.state.searchTransactionType),
            transactionStatus: parseSearchValue(this.state.searchTransactionStatus),
            currency: parseSearchValue(this.state.searchCurrency),
            paymentMethod: parseSearchValue(this.state.searchPaymentMethod),
            additionalPaymentMethod: parseSearchValue(this.state.searchAdditionalPaymentMethod),
        }
    }

    handleSearch = () => {
        const body = {
            ...this.searchBody(),
            sortName: this.state.searchSortName,
            sortAsc: this.state.searchSortAsc,
            pageIndex: this.state.pageIndex,
            pageSize: this.state.pageSize,
        }

        return new Promise((resolve, reject) => {
            this.props.startLoading();
            this.httpClient
                .get(API_SALES_INVOICE_LIST, {params: body})
                .then(response => {
                    const responseData = response.data;
                    if (responseData.data && responseData.data.length > 0) {
                        this.setState({
                            sales: responseData.data,
                            totalRecord: responseData.records,
                            totalPage: responseData.total,
                        });
                    } else {
                        this.setState({
                            sales: [],
                            totalRecord: 0,
                            totalPage: 0,
                        });
                    }
                    this.props.stopLoading();
                })
                .catch(error => {
                    handleHttpError(this.props.t, this.props.history, error);
                    this.props.stopLoading();
                    reject(error);
                })
        })
    }

    handleClickSearch = () => {
        this.setState({
            pageIndex: 1,
        }, this.handleSearch);
    }

    handleReset = () => {
        this.state.setOrderDateEnd(new Date());
        this.state.setOrderDateStart(subtractDateByDay(new Date(), 7));

        this.setState({
            searchDateButton: searchRange.ONE_WEEK,
            searchKeywordType: "",
            searchKeywordText: "",
            searchCountry: "",
            searchProductType: "",
            searchReflectionStatus: "",
            searchTransactionType: "",
            searchTransactionStatus: "",
            searchCurrency: "",
            searchPaymentMethod: "",
            searchAdditionalPaymentMethod: "",
            searchSortName: this.defaultSortName,
            searchSortAsc: false,
            pageIndex: 1,
            pageSize: 15,
            totalRecord: 0,
            totalPage: 0,
        }, this.handleSearch);
    }

    handleDownload = () => {
        const body = this.searchBody();
        return new Promise((resolve, reject) => {
            this.props.startLoading();
            this.httpClient
                .get(API_SALES_INVOICE_COUNT, {params: body})
                .then(async response => {
                    const csvBatchDownload = response.data;
                    if (csvBatchDownload) {
                        await this.handleDownloadCsvBatch();
                    } else {
                        await this.handleDownloadInHouse();
                    }
                    this.props.stopLoading();
                })
                .catch(error => {
                    handleHttpError(this.props.t, this.props.history, error);
                    this.props.stopLoading();
                    reject(error);
                })
        })
    }

    handleDownloadInHouse = async () => {
        const body = this.searchBody();
        return new Promise((resolve, reject) => {
            this.props.startLoading();
            this.httpClient
                .get(API_SALES_INVOICE_LIST_INHOUSE_DOWNLOAD, {params: body})
                .then(response => {
                    directDownload(response);
                    this.props.stopLoading();
                })
                .catch(error => {
                    handleHttpError(this.props.t, this.props.history, error);
                    this.props.stopLoading();
                    reject(error);
                })
        })
    }

    handleDownloadCsvBatch = async () => {
        const body = this.searchBody();
        return new Promise((resolve, reject) => {
            this.props.startLoading();
            this.httpClient
                .get(API_SALES_INVOICE_LIST_DOWNLOAD, {params: body})
                .then(response => {
                    const requestId = response.data;
                    this.setState({
                        openDownloadPopup: true,
                        downloadRequestId: requestId,
                    })
                    this.props.stopLoading();
                })
                .catch(error => {
                    handleHttpError(this.props.t, this.props.history, error);
                    this.props.stopLoading();
                    reject(error);
                })
        })
    }

    handleTableChange = (pageIndex, pageSize) => {
        this.setState({
            pageIndex: pageIndex,
            pageSize: pageSize,
        }, this.handleSearch);
    }

    handleTableSort = (sortOrder, sortName) => {
        this.setState({
            searchSortName: this.sortFieldMapping[sortName],
            searchSortAsc: sortOrder === 'asc',
        }, this.handleSearch);
    }

    handleRowSelect = (isSelect, rows) => {
        rows.forEach(row => {
            if (isSelect) {
                this.setState(prevState => {
                    return {
                        selectedSales: [...prevState.selectedSales, row.invoice]
                    }
                })
            } else {
                this.setState(prevState => {
                    return {
                        selectedSales: prevState.selectedSales.filter(invoice => invoice.invoiceId !== row.invoice.invoiceId)
                    }
                })
            }
        })
    }

    handleOpenSingleRefund = (invoice) => {
        this.setState({
            openSingleRefundPopup: true,
            currentInvoice: {
                appId: this.props.carousel.selectedAppId,
                invoiceId: invoice.invoiceId,
                firstInvoiceId: invoice.firstInvoiceId,
                invoiceCancelId: invoice.cancelInvoiceId,
                buyer: invoice.buyer,
                buyerGuid: invoice.buyerGuid,
                buyerUid: invoice.buyerUid,
                paymentAmount: invoice.paymentAmount,
                paymentAmountDisplay: invoice.paymentAmountDisplay,
                samsungRewardsAmount: invoice.samsungRewardsAmount,
                samsungRewardsAmountDisplay: invoice.samsungRewardsAmountDisplay,
                countryCode: invoice.countryCode,
                productTypeCd: invoice.productTypeCode,
                paymentMethodCode: invoice.paymentMethodCode,
                paymentMethod: invoice.paymentMethod,
                additionalPaymentMethod: invoice.additionalPaymentMethod,
            },
            alertPopup: findDays(new Date(invoice.orderDate), invoice.countryCode)
        })
    }

    handleCloseSingleRefund = () => {
        this.setState({
            openSingleRefundPopup: false,
            currentInvoice: undefined,
            alertPopup: false,
        });
    }

    handleSingleRefund = ({reason, refundType, refundAmount, samsungRewardsRefundAmount}) => {
        const body = {
            invoiceId: this.state.currentInvoice.invoiceId,
            buyerGuid: this.state.currentInvoice.buyerGuid,
            buyerUid: this.state.currentInvoice.buyerUid,
            countryCode: this.state.currentInvoice.countryCode,
            langCode: this.props.i18n.language,
            cancelDesc: reason,
            refundAmount: refundType === "FULL_REFUND" ? "" : setZeroRefundAmountForPartialRefund(refundAmount),
            samsungRewardsRefundAmount: refundType === "FULL_REFUND" ? "" : setZeroRefundAmountForPartialRefund(samsungRewardsRefundAmount),
        }
        return new Promise((resolve, reject) => {
            this.props.startLoading();
            this.httpClient
                .post(API_SALES_SINGLE_INVOICE_REFUND, body)
                .then(response => {
                    const responseData = response.data;
                    if (responseData.code === '100000') {
                        this.handleClickSearch();
                        this.handleCloseSingleRefund();
                        toast(this.props.t("REFUND_INVOICE_SUCCESS"));
                    } else {
                        toast(response.data.name);
                    }
                    this.props.stopLoading();
                })
                .catch(error => {
                    handleHttpError(this.props.t, this.props.history, error);
                    reject(error);
                    this.props.stopLoading();
                })
        })
    }

    handleCloseSingleRefundPopup = (isSave, reason, refundType, refundAmount, samsungRewardsRefundAmount) => {
        if (refundType === "PARTIAL_REFUND") {
            if (checkEmptyRefundAmountForPartialRefund(refundAmount, samsungRewardsRefundAmount)) {
                toast(this.props.t("PLEASE_ENTER_THE_REFUND_AMOUNT"));
                return Promise.resolve(this.props.t("CONDITION_NOT_MET"));
            }
            let partialRefundAmountFloat = parseFloat(refundAmount);
            let partialSamsungRewardsRefundAmountFloat = parseFloat(samsungRewardsRefundAmount);
            let paymentAmount = parseFloat(this.state.currentInvoice.paymentAmount);
            let samsungRewardsUsedAmount = parseFloat(this.state.currentInvoice.samsungRewardsAmount)
            if (checkRefundAmountValidForPartialRefund(partialRefundAmountFloat, partialSamsungRewardsRefundAmountFloat)) {
                toast(this.props.t("PLEASE_ENTER_VALID_REFUND_AMOUNT"));
                return Promise.resolve(this.props.t("CONDITION_NOT_MET"));
            }
            if (checkRefundAmountExceedPaymentAmount(partialRefundAmountFloat, partialSamsungRewardsRefundAmountFloat, paymentAmount, samsungRewardsUsedAmount)) {
                toast(this.props.t("PARTIAL_REFUND_AMOUNT_GREATER_THAN_FULL_PAYMENT_AMOUNT"));
                return Promise.resolve(this.props.t("CONDITION_NOT_MET"));
            }
        }

        if (!isSave) {
            return this.handleCloseSingleRefund();
        }

        return this.handleSingleRefund({reason, refundType, refundAmount, samsungRewardsRefundAmount});
    }

    handleOpenMultipleRefund = () => {
        this.setState({
            openMultipleRefundPopup: true,
        })
    }

    handleCloseMultipleRefund = () => {
        this.setState({
            openMultipleRefundPopup: false,
        })
    }

    handleMultipleRefund = () => {
        this.props.startLoading();
        const body = this.state.selectedSales.map(invoice => {
            return {
                invoiceId: invoice.invoiceId,
                buyerGuid: invoice.buyerGuid,
                buyerUid: invoice.buyerUid,
                countryCode: invoice.countryCode,
                langCode: this.props.i18n.language,
            }
        })

        return new Promise((resolve, reject) => {
            this.httpClient
                .post(API_SALES_MULTIPLE_INVOICE_REFUND, body)
                .then((response) => {
                    this.handleClickSearch();
                    this.handleCloseMultipleRefund();
                    this.setState({selectedSales: []});
                    toast(`${response.data.completeCancelRequest} / ${response.data.totalCancelRequest} Invoices Refunded`);
                    this.props.stopLoading();
                })
                .catch(error => {
                    handleHttpError(this.props.t, this.props.history, error);
                    this.props.stopLoading();
                    reject(error);
                })
        })
    }

    getCountryOptions = () => {
        return this.props.countriesInformation.map(country => {
            return {
                value: country.country,
                label: `${country.countryName}`
            }
        }).sort(sortOptions);
    }

    getCurrencyOptions = () => {
        return this.props.countriesInformation
            .map(country => country.currency)
            .filter((value, index, array) => array.indexOf(value) === index)
            .map(currency => {
                return {
                    value: currency,
                    label: currency,
                }
            })
            .sort(sortOptions);
    }

    getOptionsWithTranslation = (options) => {
        return options.map(key => ({
            value: key.value,
            label: this.props.t(key.label),
        }));
    }

    render() {
        return (
            <div className="tab-pane active" role="tabpanel">
                <div className={'search_field'}>
                    <div className={'form-group row align-items-center'}>
                        <label className={'col col-form-label'}>
                            {this.props.t('KEYWORD')}
                            <Tooltip>
                                {this.props.t("KEYWORD_MULTI_SEARCH_TOOLTIP")}
                            </Tooltip>
                        </label>
                        <div className={'col d-flex flex-row align-items-center'} style={{gap: '0.6rem'}}>
                            <Select
                                options={this.keywordTypeOptions}
                                value={this.state.searchKeywordType}
                                onChange={value => this.setState({searchKeywordType: value, searchKeywordText: ''})}
                                placeholder={this.props.t('CHOOSE_KEYWORD')}
                                style={{minWidth: '14rem'}}
                                noMaxHeight={true}
                            />
                            <TextInput
                                placeholder={this.props.t('PLEASE_ENTER_KEYWORD')}
                                value={this.state.searchKeywordText}
                                onChange={value => this.setState({searchKeywordText: value})}
                                disabled={!this.state.searchKeywordType}
                            />
                            <button type={'button'} onClick={this.handleClickSearch} className={'btn btn-primary'}>
                                {this.props.t('SEARCH')}
                            </button>
                            <button type={'button'} onClick={this.handleReset} className={'btn btn-icon'} style={{minWidth: '4rem'}}>
                                <i className={'icon icon-refrash'}/>
                            </button>
                            <button type={'button'} onClick={this.handleDownload} className={'btn btn-outline-primary'}>
                                {this.props.t('DOWNLOAD')}
                            </button>
                        </div>
                    </div>
                    <div className={'form-group row align-items-center'}>
                        <label className={'col col-form-label'}>
                            {this.props.t('ORDER_DATE')}
                        </label>
                        <div className={'col d-flex flex-row align-items-center'} style={{gap: '0.6rem'}}>
                            <div style={{width: '8rem'}}>
                                <DatePickerX
                                    onInit={datePicker => this.setState({
                                        getOrderDateStart: datePicker.getValue,
                                        setOrderDateStart: datePicker.setValue,
                                    })}
                                    defaultValue={subtractDateByDay(new Date(), this.state.searchDateButton)}
                                />
                            </div>
                            <span>
                                ~
                            </span>
                            <div style={{width: '8rem'}}>
                                <DatePickerX
                                    onInit={datePicker => this.setState({
                                        getOrderDateEnd: datePicker.getValue,
                                        setOrderDateEnd: datePicker.setValue,
                                    })}
                                    defaultValue={new Date()}
                                />
                            </div>
                            <div className={'btn-group'}>
                                <button type={'button'} onClick={this.handleChangeSearchDateButton(searchRange.ONE_WEEK)} className={`btn btn-outline-500 ${this.state.searchDateButton === searchRange.ONE_WEEK ? 'checked' : ''}`}>
                                    {this.props.t('ONE_WEEK')}
                                </button>
                                <button type={'button'} onClick={this.handleChangeSearchDateButton(searchRange.ONE_MONTH)} className={`btn btn-outline-500 ${this.state.searchDateButton === searchRange.ONE_MONTH ? 'checked' : ''}`}>
                                    {this.props.t('ONE_MONTH')}
                                </button>
                                <button type={'button'} onClick={this.handleChangeSearchDateButton(searchRange.SIX_MONTHS)} className={`btn btn-outline-500 ${this.state.searchDateButton === searchRange.SIX_MONTHS ? 'checked' : ''}`}>
                                    {this.props.t('SIX_MONTHS')}
                                </button>
                                <button type={'button'} onClick={this.handleChangeSearchDateButton(searchRange.ONE_YEAR)} className={`btn btn-outline-500 ${this.state.searchDateButton === searchRange.ONE_YEAR ? 'checked' : ''}`}>
                                    {this.props.t('ONE_YEAR')}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className={'form-group row align-items-start'}>
                        <label className={'col col-form-label'}>
                            {this.props.t('FILTERS')}
                        </label>
                        <div className={'col d-flex flex-row'}>
                            <div style={{display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '0.6rem'}}>
                                <Select
                                    options={this.getCountryOptions()}
                                    value={this.state.searchCountry}
                                    onChange={value => this.setState({searchCountry: value})}
                                    placeholder={this.props.t('COUNTRY')}
                                    style={{minWidth: '14rem'}}
                                />
                                <Select
                                    options={productTypeOptions}
                                    value={this.state.searchProductType}
                                    onChange={value => this.setState({searchProductType: value})}
                                    placeholder={this.props.t('PRODUCT_TYPE')}
                                    style={{minWidth: '14rem'}}
                                    noMaxHeight={true}
                                />
                                <Select
                                    options={reflectionStatusOptions}
                                    value={this.state.searchReflectionStatus}
                                    onChange={value => this.setState({searchReflectionStatus: value})}
                                    placeholder={this.props.t('REFLECTION_STATUS')}
                                    style={{minWidth: '14rem'}}
                                    noMaxHeight={true}
                                />
                                <Select
                                    options={transactionTypeOptions}
                                    value={this.state.searchTransactionType}
                                    onChange={value => this.setState({searchTransactionType: value})}
                                    placeholder={this.props.t('TRANSACTION_TYPE')}
                                    style={{minWidth: '14rem'}}
                                    noMaxHeight={true}
                                />
                                <Select
                                    options={this.getOptionsWithTranslation(transactionStatusOptions)}
                                    value={this.state.searchTransactionStatus}
                                    onChange={value => this.setState({searchTransactionStatus: value})}
                                    placeholder={this.props.t('TRANSACTION_STATUS')}
                                    style={{minWidth: '14rem'}}
                                    noMaxHeight={true}
                                />
                                <Select
                                    options={this.getCurrencyOptions()}
                                    value={this.state.searchCurrency}
                                    onChange={value => this.setState({searchCurrency: value})}
                                    placeholder={this.props.t('CURRENCY')}
                                    style={{minWidth: '14rem'}}
                                />
                                <Select
                                    options={paymentMethodOptions}
                                    value={this.state.searchPaymentMethod}
                                    onChange={value => this.setState({searchPaymentMethod: value})}
                                    placeholder={this.props.t('PAYMENT_METHOD')}
                                    style={{minWidth: '14rem'}}
                                    noMaxHeight={true}
                                />
                                <Select
                                    options={additionalPaymentMethodOptions}
                                    value={this.state.searchAdditionalPaymentMethod}
                                    onChange={value => this.setState({searchAdditionalPaymentMethod: value})}
                                    placeholder={this.props.t('ADDITIONAL_PAYMENT_METHOD')}
                                    style={{minWidth: '14rem'}}
                                    noMaxHeight={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <DataTableWrapperForListing
                    noSelect
                    wrapperClasses="table-responsive"
                    keyField="index"
                    columns={this.defaultColumns}
                    page={this.state.pageIndex}
                    sizePerPage={this.state.pageSize}
                    totalSize={this.state.totalRecord}
                    rows={this.state.sales.map(invoice => {
                        return {
                            ...invoice,
                            index: invoice.invoiceId,
                            invoice: invoice,
                            invoiceIdLink: (
                                <Link
                                    title={invoice.invoiceId}
                                    to={`${URL_SALES_SALESPRODUCT}/${invoice.cancelInvoiceId || invoice.invoiceId}`}
                                >
                                    {invoice.invoiceId}
                                </Link>
                            ),
                            settlementAppId: invoice.settlementAppId !== "-" ? invoice.settlementAppId : invoice.appId,
                            settlementAppName: invoice.settlementAppName !== "-" ? invoice.settlementAppName : invoice.appName,
                            transactionType: invoice.transactionType === "Y" ? "Test" : "Real",
                            subscriptionGroupType: invoice.subscriptionGroupType !== "" ? this.props.t(invoice.subscriptionGroupType) : "-",
                            productIdLink: (
                                <Link
                                    title={invoice.cpProductId}
                                    to={`${URL_PRODUCT_DETAIL}/${invoice.productId}`}
                                >
                                    {invoice.cpProductId}
                                </Link>
                            ),
                            cancelDate: invoice.cancelDate || (
                                <button
                                    type={'button'}
                                    className={'btn btn-outline-primary'}
                                    onClick={() => this.handleOpenSingleRefund(invoice)}
                                >
                                    {this.props.t("REFUND")}
                                </button>
                            )
                        }
                    })}
                    onTableSort={this.handleTableSort}
                    onTableChange={this.handleTableChange}
                    onRowSelect={this.handleRowSelect}
                    nonSelectableRows={
                        this.state.sales
                            .filter(invoice => !!invoice.cancelDate)
                            .map(invoice => invoice.invoiceId)
                    }
                    defaultSorted={[{dataField: 'orderDate', order: 'desc'}]}
                />
                <div className={'d-flex flex-row mt-10'}>
                    <button
                        type={'button'}
                        className={`btn btn-primary ${this.state.selectedSales.length === 0 ? 'disabled' : ''}`}
                        disabled={this.state.selectedSales.length === 0}
                        onClick={this.handleOpenMultipleRefund}
                    >
                        {this.props.t("MULTIPLE_REFUND")}
                    </button>
                </div>
                <BasePopup
                    open={this.state.openDownloadPopup}
                    className={"modal-sm"}
                    style={{maxWidth: '26rem'}}
                    title={this.props.t("CSV_DOWNLOAD_REQUEST")}
                    onClose={() => this.setState({openDownloadPopup: false})}
                    body={(
                        <div>
                            {this.props.t("CSV_DOWNLOAD_REQUEST_MESSAGE").replace("{REQUEST_ID}", this.state.downloadRequestId)}
                        </div>
                    )}
                    footer={(
                        <div className={'d-flex flex-row'} style={{gap: '0.6rem'}}>
                            <button type="button" className="btn btn-primary" onClick={() => this.setState({openDownloadPopup: false})}>
                                {this.props.t("OK")}
                            </button>
                            <Link to={URL_REQUEST_LIST} className="btn btn-outline-primary">
                                {this.props.t("CSV_DOWNLOAD_REPOSITORY")}
                            </Link>
                        </div>
                    )}
                />
                {this.state.currentInvoice &&
                    <RequestRefundPopUp
                        key={this.state.currentInvoice.invoiceId}
                        currentInvoice={this.state.currentInvoice}
                        invoiceId={this.state.currentInvoice.invoiceId}
                        buyer={this.state.currentInvoice.buyer}
                        samsungRewardsUsedAmount={this.state.currentInvoice.samsungRewardsAmount}
                        samsungRewardsUsedAmountDisplay={this.state.currentInvoice.samsungRewardsAmountDisplay}
                        paymentAmount={this.state.currentInvoice.paymentAmountDisplay}
                        paymentAmountNumber={this.state.currentInvoice.paymentAmount}
                        paymentMethod={this.state.currentInvoice.paymentMethod}
                        additionalPaymentInfo={this.state.currentInvoice.additionalPaymentMethod}
                        open={this.state.openSingleRefundPopup}
                        alertPopup={this.state.alertPopup}
                        handlePopupClose={this.handleCloseSingleRefundPopup}
                    />
                }
                <BasePopup
                    open={this.state.openMultipleRefundPopup}
                    className="modal-lg"
                    title={this.props.t('MULTIPLE_REFUND')}
                    onClose={this.handleCloseMultipleRefund}
                    body={
                        <DataTableWrapperForListing
                            noSelect
                            hideSelectColumn
                            disableFooter
                            wrapperClasses="table-responsive"
                            keyField="index"
                            columns={this.multipleRefundColumns}
                            rows={this.state.selectedSales.map(invoice => {
                                return {
                                    ...invoice,
                                    index: invoice.invoiceId,
                                    invoiceIdLink: (
                                        <Link
                                            title={invoice.invoiceId}
                                            to={`${URL_SALES_SALESPRODUCT}/${invoice.cancelInvoiceId || invoice.invoiceId}`}
                                        >
                                            {invoice.invoiceId}
                                        </Link>
                                    ),
                                    productIdLink: (
                                        <Link
                                            title={invoice.cpProductId}
                                            to={`${URL_PRODUCT_DETAIL}/${invoice.productId}`}
                                        >
                                            {invoice.cpProductId}
                                        </Link>
                                    ),
                                }
                            })}
                        />
                    }
                    footer={
                        <div className={'d-flex flex-row'} style={{gap: '0.6rem'}}>
                            <button type="button" className="btn btn-secondary" onClick={this.handleMultipleRefund}>
                                {this.props.t("REFUND")}
                            </button>
                            <button type="button" className="btn btn-outline-secondary" onClick={this.handleCloseMultipleRefund}>
                                {this.props.t("CANCEL")}
                            </button>
                        </div>
                    }
                />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        carousel: state.carousel,
        countriesInformation: state.countriesInformation
    };
};

const mapDispatchToProps = {
    startLoading: startLoading,
    stopLoading: stopLoading
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouter(InvoiceListPanel)));